import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ShieldCheck } from 'lucide-react';
import { Button } from './ui/Button';
export function Hero() {
  const scrollToPurchase = () => {
    document.getElementById('kits')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.4
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      x: -20
    },
    show: {
      opacity: 1,
      x: 0,
      transition: {
        type: 'spring',
        stiffness: 100
      }
    }
  };
  return <section className="relative pt-6 pb-10 lg:pt-8 lg:pb-14 overflow-visible px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-145">
      <div className="flex justify-center mb-6 lg:mb-8 flex-col items-center" data-id="element-146">
        <img src="https://cdn.magicpatterns.com/uploads/qJustZMxmxDKBZsGFJMSjj/LOGO_DECOEMPRENDE.png" alt="Deco Emprende Logo" className="h-32 sm:h-44 object-contain" data-id="element-147" />
      </div>

      <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center" data-id="element-148">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="max-w-2xl flex flex-col items-center text-center lg:items-start lg:text-left" data-id="element-149">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl leading-[1.1] mb-6 text-deco-text font-bold" data-id="element-150">
            Aprendé a crear{' '}
            <span className="text-deco-terra font-script text-5xl sm:text-6xl lg:text-7xl font-normal px-2 block sm:inline" data-id="element-151">
              flores de chenille
            </span>{' '}
            y convertí tus diseños en una oportunidad para vender desde casa
          </h1>

          

          <motion.div variants={containerVariants} initial="hidden" animate="show" className="flex flex-col gap-3 sm:gap-4 mb-8 w-full max-w-md mx-auto lg:mx-0" data-id="element-152">
            {['Aprendé desde cero paso a paso', 'Creá flores, ramos y productos para vender', 'Ideal para empezar un ingreso extra desde casa'].map((bullet, i) => <motion.div key={i} variants={itemVariants} className="flex items-center gap-3 sm:gap-4 bg-white/80 backdrop-blur-sm p-3 sm:p-4 rounded-2xl border border-deco-warm shadow-sm" data-id="element-153">
                <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-deco-bg flex items-center justify-center text-deco-terra shrink-0 border border-deco-warm" data-id="element-154">
                  <CheckCircle2 size={20} className="sm:w-5 sm:h-5" data-id="element-155" />
                </div>
                <span className="text-deco-text font-medium text-sm sm:text-base text-left" data-id="element-156">
                  {bullet}
                </span>
              </motion.div>)}
          </motion.div>

          <motion.div whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.97
        }} className="w-full sm:w-auto rounded-full flex flex-col items-center lg:items-start" data-id="element-157">
            <Button onClick={scrollToPurchase} className="w-full sm:w-auto text-base sm:text-lg px-8 py-4 sm:px-12 sm:py-5 shadow-lg hover:shadow-xl rounded-full bg-deco-terra text-white font-bold transition-all border-2 border-deco-terra/20" data-id="element-158">
              QUIERO EMPEZAR
            </Button>
            <div className="flex items-center gap-2 mt-4 text-xs sm:text-sm text-deco-muted font-medium" data-id="element-159">
              <ShieldCheck size={16} data-id="element-160" />
              <span data-id="element-161">Acceso inmediato · Producto digital</span>
            </div>
          </motion.div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="relative mt-8 lg:mt-0 px-2 sm:px-0 flex justify-center" data-id="element-162">
          <div className="absolute -top-6 -right-6 w-24 h-24 bg-deco-warm rounded-full blur-2xl -z-10" data-id="element-163"></div>
          <div className="absolute -bottom-8 -left-8 w-32 h-32 bg-deco-sage/20 rounded-full blur-2xl -z-10" data-id="element-164"></div>

          <div className="relative rounded-[2rem] overflow-hidden shadow-2xl border-4 sm:border-8 border-white aspect-[9/16] max-w-sm w-full bg-deco-card" data-id="element-165">
            <video src="https://cdn.magicpatterns.com/uploads/f47J9sHv1Dgvn1KffE5Umx/IMG_7852.MP4" autoPlay loop muted playsInline className="w-full h-full object-cover" data-id="element-166" />
          </div>

          <div className="absolute -bottom-4 right-4 sm:right-10 bg-white text-deco-text px-4 py-2 rounded-xl shadow-xl border border-deco-warm font-bold text-sm flex items-center gap-2 transform rotate-3" data-id="element-167">
            <span data-id="element-168">Aprendés</span>
            <span className="text-deco-terra" data-id="element-169">•</span>
            <span data-id="element-170">Creás</span>
            <span className="text-deco-terra" data-id="element-171">•</span>
            <span data-id="element-172">Vendés</span>
          </div>
        </motion.div>
      </div>
    </section>;
}